export enum BatteryState {
  Unknown,
  Charging,
  Discharging,
  Full,
  NotCharging,
  NotPresent
}
